import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./AuthStatus.html';
import styles from './AuthStatus-hashed.scss';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import appFeatures from 'effective-features!';
import AuthComponentUtils from '../common/AuthComponentUtils';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default {
    template: hashedTemplate,
    bindings: {
        showPreferences: '='
    },
    controller: ['$state', 'oAuth', 'gwAuthTokenService', '$scope', '$rootScope', 'ModalService', function ($state, oAuth, gwAuthTokenService, $scope, $rootScope, ModalService) {
        // VARS
        var $ctrl = this;
        var homeLogin = 'authLogin';
        var authenticationService = AuthenticationService(oAuth);

        // HELPERS
        function getUsersprofileRoute() {
            // check if userprofile is provided
            var checkForEnrollment = appFeatures['self-enrollment'];
            if (!checkForEnrollment || !checkForEnrollment.usersprofileRoute) {
                return undefined;
            }

            return checkForEnrollment.usersprofileRoute;
        }

        var setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $scope);

        // METHODS
        $ctrl.login = function () {
            $state.go(homeLogin);
        };

        $ctrl.logout = function () {

            console.info('Let\'s see if we can get the token to go away');
            if ($rootScope.restrictNavigationStatus) {
                event.preventDefault();
                ModalService.showError('', 'quoteandbind.common.config.FlowConfig.Please accept or withdraw the policy change transaction.');
                return false;
            } else {
                var checkIfTokenExists = window.location.href.indexOf('?');
                if (checkIfTokenExists > -1) {
                    //get full URL
                    var currURL = window.location.href; //get current address
                    var firstPartURL = window.location.href.split("?")[0]; //"http://www.newurl.com";
                    //Get the URL between what's after '?' and before '#'
                    //1- get URL after'?'
                    var afterDomain = currURL.substring(currURL.lastIndexOf('?'));
                    //2- get the part after '#'
                    var afterQueryString = afterDomain.split("#")[1];
                    var myNewURL = firstPartURL + "#" + afterQueryString;
                    window.location.href = myNewURL;
                }
                authenticationService.logout();
            }
        };

        // INIT
        $ctrl.$onInit = function () {
            $ctrl.usersprofileRoute = getUsersprofileRoute();

            $ctrl.userHasAuthoritites = false;
            // wait for the user's authorities
            gwAuthTokenService.grantedAuthorities.then(function (grantedAuthorities) {
                if (grantedAuthorities.length) {
                    setCtrlParam('userHasAuthoritites', true);
                } else {
                    setCtrlParam('userHasAuthoritites', false);
                }
            });
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/AuthStatus/index.js
// module id = 1327
// module chunks = 0